import { MILLION_LINT_OPTIMIZATION_241118 } from "@faire/web-api--source/indigofair/settings/MILLION_LINT_OPTIMIZATION_241118";

import { getSettingValueAndAssign } from "@faire/retailer/settings/__internal__/getSetting";

export const getSettingAndAssignMillionLintOptimization = () =>
  getSettingValueAndAssign(MILLION_LINT_OPTIMIZATION_241118, false);
